import { ErrorSpreadsheetResult } from "../../../util/spreadsheet-data-utils";

export type GetIfDefinitionCommonValidationResultResponse = {
  /**
   * The results of this get_if_definition_common_validation_result response body.
   */
  result: ErrorSpreadsheetResult[];
};
